import React, { useState } from 'react';
import { View } from 'react-native';
import SwitcherButton from './SwitcherButton';
import RegularText from '../Text/RegularText';
import ExpandedText from './ExpandedText';

//= ========================================================================

const SwitcherPanel = ({
  key,
  text,
  value,
  onValueChanged,
  alwaysOn,
  forceDisable,
  internalFlag,
  children,
  marginBottom = 14,
  marginTop = 0,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <View key={key}>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginTop,
          marginBottom,
          backgroundColor: internalFlag ? '#f7fafc' : null,
          padding: internalFlag ? 14 : 0,
          paddingStart: internalFlag ? 20 : 0,
          paddingEnd: internalFlag ? 20 : 0,
        }}
      >
        {children
          ? (
            <ExpandedText isExpanded={isExpanded} onPress={() => setIsExpanded(!isExpanded)}>
              <RegularText marginBottom={0}>{text}</RegularText>
            </ExpandedText>
          )
          : <RegularText marginBottom={internalFlag && 0}>{text}</RegularText>}
        <SwitcherButton
          value={value}
          onValueChanged={onValueChanged}
          alwaysOn={alwaysOn}
          forceDisable={forceDisable}
        />
      </View>
      {isExpanded && children}
    </View>
  );
};

export default SwitcherPanel;
